import { render } from "./minOrderAlert.vue?vue&type=template&id=453297a0"
import script from "./minOrderAlert.vue?vue&type=script&lang=js"
export * from "./minOrderAlert.vue?vue&type=script&lang=js"

import "./minOrderAlert.vue?vue&type=style&index=0&id=453297a0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__